import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import DataGrid from '../DataGrid';

import styles from './styles';

import DateTimeFormatter from './formatters/DateTimeFormatter';
import AttrFormatter from './formatters/AttrFormatter';
import BoldFormatter from './formatters/BoldFormatter';
import CarouselReadCell from './formatters/CarouselReadCell';
import MultiSelectReadCell from '../SectionListCrud/editCells/MultiSelectReadCell';

const useStyles = createUseStyles(styles, 'SectionList');
const EMPTY_COLUMNS = [];
const EMPTY_VIEW_PROPS = {};

const DateTimeFormatterCell = ({ value }) => <DateTimeFormatter date={value} />;
const AttrFormatterCell = (props) => <AttrFormatter {...props} />;

function SectionList({
    id,
    className,
    rows,
    actions,
    hideActions,
    isLoading,
    hasError,
    components,
    options,
    columns = EMPTY_COLUMNS,
    emptyViewProps = EMPTY_VIEW_PROPS,
    ...props
}) {
    const classes = useStyles();
    const rootClassName = classnames(classes.root, className);
    const vanillaComponents = useMemo(
        () => ({
            BoldFormatter,
        }),
        [],
    );

    // TODO Refactor to DataGrid vanilla components
    const gridComponents = useMemo(
        () => ({
            DateTimeFormatter: DateTimeFormatterCell,
            AttrFormatter: AttrFormatterCell,
            CarouselReadCell,
            MultiSelectReadCell,
            ...components,
        }),
        [components],
    );

    return (
        <DataGrid
            id={id}
            className={rootClassName}
            columnDefs={columns}
            rowData={rows}
            isLoading={isLoading}
            hasError={hasError}
            components={gridComponents}
            vanillaComponents={vanillaComponents}
            actions={actions}
            hideActions={hideActions}
            emptyViewProps={emptyViewProps}
            {...options}
            {...props}
        />
    );
}

SectionList.propTypes = {
    id: PropTypes.string,
    rows: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.object),
    actions: PropTypes.arrayOf(PropTypes.any),
    isLoading: PropTypes.bool,
    hasError: PropTypes.bool,
};

export default React.memo(SectionList);
